import useAuth from 'hooks/useAuth';
import { useClassifiers } from 'utils/useClassifiers';
import { useTimecardPrecision } from 'utils/useTimecardPrecision';
import { TimecardFormContext } from './timecardFormMapping';

const CONTEXT_CLASSIFIERS = ['TIMECARD_ACTIVITY_TYPE', 'TIMECARD_VALUE_FACTORS'];

/**
 * What `timecardDtoToForm` needs: the activity-type and value-factor options, and the hours' precision. Its own
 * module, so the app shell's timer can finish a draft without pulling in the timecard form.
 */
export const useTimecardFormContext = (): { context: TimecardFormContext; isLoading: boolean } => {
    const { user } = useAuth();
    const { classifiers, isLoading } = useClassifiers({ codes: CONTEXT_CLASSIFIERS });
    const { isTwoDecimalEntryEnabled } = useTimecardPrecision();
    const currentUser = user?.id && user.name ? { id: user.id, name: user.name } : undefined;
    return { context: { classifiers, isTwoDecimalEntryEnabled, currentUser }, isLoading };
};
